import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "arcgis-wrapper relative",
    style: {
      height: _vm.tagShow ? "calc(100vh - 148px)" : "calc(100vh - 102px)"
    }
  }, [_vm.map ? _c("div", {
    staticClass: "handle-list flex flex-wrap align-content-around"
  }, _vm._l(_vm.handleList, function (item) {
    return _c("div", {
      key: item.icon,
      staticClass: "handle-item",
      on: {
        click: function ($event) {
          return _vm.changeHandle(item.icon);
        }
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "right"
      }
    }, [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c("svg-icon", {
      attrs: {
        icon: item.icon,
        size: 21,
        color: item.icon == _vm.currentKey ? "#fff" : "#cecece"
      }
    })], 2)], 1);
  }), 0) : _vm._e(), _c("base-map", {
    staticClass: "all-container",
    attrs: {
      current: _vm.currentKey
    },
    on: {
      sendMap: _vm.getMap
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };